import Box from '@mui/material/Box';
import React, { memo } from 'react';

import { petrol } from '../../../styles/mui/colors';
import dayjs from '../../../util/dayjs';
import ListingCardTag from './ListingCardTag';
import ListingCardNewTag from './ListingCardTagNew';
import ListingCardPlusTag from './ListingCardTagPlus';
import ListingCardVerifiedTag from './ListingCardTagVerified';

const NEW_TAG_DAYS = 14;

const styles = {
  display: 'flex',
  flexDirection: 'row',
  gap: 1,
  borderRadius: '50px',
  position: 'absolute',
  zIndex: 1,
  top: '10px',
  left: '10px',
  padding: '5px 10px',
  backgroundColor: petrol.main,
  color: '#fff',
  height: '30px',
  justifyContent: 'center',
  alignItems: 'center',
};

const ListingCardTagContainerComponent = ({
  createdAt,
  isVerifiedListing = false,
  isPlus = false,
}) => {
  const isNew = createdAt && dayjs().diff(createdAt, 'days') <= NEW_TAG_DAYS;
  const tags = [
    ...(isVerifiedListing ? [<ListingCardVerifiedTag key="verified-key" />] : []),
    ...(isNew ? [<ListingCardNewTag key="new-key" />] : []),
    ...(isPlus ? [<ListingCardPlusTag key="plus-key" />] : []),
  ];
  const tagElements = [].concat(...tags.map((n, i) => [n, <div key={i}>•</div>])).slice(0, -1);
  if (tagElements.length === 0) return null;

  return (
    <Box sx={styles}>
      {tagElements.map((tag, i) => (
        <ListingCardTag key={i} tag={tag} />
      ))}
    </Box>
  );
};

const ListingCardTagContainer = memo(ListingCardTagContainerComponent);
ListingCardTagContainer.displayName = 'ListingCardTagContainer';

export default ListingCardTagContainer;
